import { render, staticRenderFns } from "./index.vue?vue&type=template&id=228c378f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=228c378f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c378f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228c378f')) {
      api.createRecord('228c378f', component.options)
    } else {
      api.reload('228c378f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=228c378f&scoped=true&", function () {
      api.rerender('228c378f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/charts/vacations/components/table/workers-group/index.vue"
export default component.exports